






































import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
// @ts-ignore
import store from "../../../store";
// @ts-ignore
import MessageHelper from "../../../helpers/MessageHelper";
import type {Player, PlayerAutomationStatus} from "../../../../types";
import MafiaVoting from "./MafiaVoting.vue";
import EventApi from "../../../api/EventsApi";
import SeatExternalVotingResults from "../../Voting/SeatExternalVotingResults.vue";

const NEXT_SPEAKER = 'nextSpeaker';

@Component({
    components: {SeatExternalVotingResults, MafiaVoting},
})

/** Кнопки голосования за игру */
export default class MafiaButtons extends Vue {
    @Prop({required: true}) private readonly isMaster!: boolean;
    @Prop({required: true}) private readonly masterId!: string|null;
    @Prop({required: true}) private readonly period!: string;
    @Prop({required: true}) private readonly seat!: Player;

    private votingButtonIsVisible: boolean = false;
    private votingResultIsVisible: boolean = false;
    private votingResultMessage: any|null = null;
    private isVoteDecisionDone: boolean = false;
    private isVotingControlVisible: boolean = true;
    private isPressedButtonAfterExecution: boolean = false;
    private executedSeatId: string = '';
    private nightActionId: string = '';

    mounted(): void
    {
        EventApi.addEventListener(EventApi.START_EXTERNAL_VOTING, this.showVoting);
        EventApi.addEventListener(EventApi.HIDE_EXTERNAL_VOTING, this.hideVoting);
        EventApi.addEventListener(EventApi.SHOW_EXTERNAL_VOTE_RESULT, this.showVotingResult);
        EventApi.addEventListener(EventApi.HIDE_EXTERNAL_VOTE_RESULT, this.hideVotingResult);
        EventApi.addEventListener(EventApi.MAKE_VOTING_DECISION, this.makeDecision);
        EventApi.addEventListener(EventApi.RESET_GAME, this.resetGame);
    }

    beforeDestroy():void
    {
        EventApi.removeEventListener(EventApi.START_EXTERNAL_VOTING, this.showVoting);
        EventApi.removeEventListener(EventApi.HIDE_EXTERNAL_VOTING, this.hideVoting);
        EventApi.removeEventListener(EventApi.SHOW_EXTERNAL_VOTE_RESULT, this.showVotingResult);
        EventApi.removeEventListener(EventApi.HIDE_EXTERNAL_VOTE_RESULT, this.hideVotingResult);
        EventApi.removeEventListener(EventApi.MAKE_VOTING_DECISION, this.makeDecision);
        EventApi.removeEventListener(EventApi.RESET_GAME, this.resetGame);
    }

    /**
     * Смотрим изменения дня/ночи для мафии.
     * Если наступает ночь, то очищаем рез-таты предыдущего дневного голосования
     * Если наступает день, сбрасываем флаг о том, что игрок проголосовал
     * @param newVal
     * @param oldVal
     */
    @Watch('period')
    onGamePeriodChange(newVal: string, oldVal: string)
    {
        if ((newVal === 'night' && oldVal === 'day')) {
            this.hideVotingResult();
            this.isVoteDecisionDone = false;
            this.isVotingControlVisible = true;
            this.executedSeatId = '';
        }
        if (newVal === 'day' && oldVal === 'night') {
            this.isVoteDecisionDone = false;
            this.nightActionId = '';
        }
    }

    @Watch('playerStatus')
    onPlayerStatusChange(newVal: PlayerAutomationStatus, oldVal: PlayerAutomationStatus)
    {
        if ((newVal.value === 2 || newVal.value === 3)
            && !this.isPressedButtonAfterExecution
            && this.isMaster
            && this.playerId === this.masterId) {
            setTimeout(() => {
                this.isVoteDecisionDone = false;
                this.isVotingControlVisible = false;
            }, 10000);
        }
    }

    @Watch('isMaster')
    onMasterStatusChange(newVal: boolean, oldVal: boolean)
    {
        if (!newVal && this.playerStatus?.value === 2 || this.playerStatus?.value === 3) {
            this.isVoteDecisionDone = true;
            this.isVotingControlVisible = true;
        }
        if (this.playerStatus?.value === 1
            && this.votingResultIsVisible
            && this.playerId === this.seat.id) {
            if (newVal && this.playerId === this.masterId) {
                setTimeout(() => {
                    this.isVoteDecisionDone = false;
                    this.isVotingControlVisible = false;
                }, 10000);
            }
            if (!newVal && this.playerId !== this.masterId) {
                this.isVoteDecisionDone = true;
                this.isVotingControlVisible = true;
            }
        }
        if (newVal) {
            this.isPressedButtonAfterExecution = false;
        }
    }

    /**
     * Статус игрока в автоматизации игры
     */
    private get playerStatus(): PlayerAutomationStatus|null
    {
        return store.getters.getPlayerAutomationStatus(this.seat.id);
    }

    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    private get currentPlayer(): Player|null
    {
        const filtered = this.players.filter(player => player.id === this.playerId);
        if (typeof filtered[0] !== 'undefined') {
            return filtered[0];
        }
        return null;
    }

    /**
     * Имя игрока по ID
     * @private
     */
    private get playerName(): string
    {
        return this.gameState.playersData[this.playerId].name.toString();
    }

    /** Видимость кнопки "Передать слово" */
    private get isNextSpeakerButtonVisible(): boolean
    {
        if (!this.gameState.zones.chat.buttons.mafia) {
            return false;
        }
        const button = this.gameState.zones.chat.buttons.mafia.nextSpeaker;
        if (this.votingButtonIsVisible || this.votingResultIsVisible) {
            if (!this.isVotingControlVisible && this.isMaster && this.playerId === this.masterId) {
                return button.enabled;
            }
            return false;
        }

        if (!this.isMaster || this.playerId !== this.masterId) {
            return false;
        }

        if (typeof button === 'undefined' || !button.enabled) {
            return false;
        }

        if (!button.visibleFor.length) {
            return true;
        }

        if (button.visibleFor.indexOf(this.playerId) === -1) {
            return false;
        }

        if (!button) {
            return false;
        }

        return button.enabled;
    }

    /** Нажатие на кнопку "Передать слово" */
    private clickNextSpeakerButton(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        MessageHelper.clickCustomButtonMessage({
            zone: 'chat',
            type: NEXT_SPEAKER,
        });
        if (this.votingResultIsVisible) {
            this.isVoteDecisionDone = true;
            this.isVotingControlVisible = true;
            this.isPressedButtonAfterExecution = true;
        }
    }

    /**
     * Показать голосование
     * @private
     */
    private showVoting(data: any): void
    {
        this.executedSeatId = '';
        this.nightActionId = '';
        const optionsGroups = data.detail.data.optionsGroups[0];
        if (typeof optionsGroups !== 'undefined') {
            optionsGroups.options.forEach((option: any) => {
                if (option.text === this.seat.id) {
                    this.votingButtonIsVisible = true;
                    this.hideVotingResult();
                }
            });
        }
    }

    /**
     * Скрыть голосование
     * @private
     */
    private hideVoting(): void
    {
        this.votingButtonIsVisible = false;
    }

    private setExecutedId(id: string)
    {
        this.executedSeatId = id;
    }

    private setNightActionId(id: string)
    {
        this.nightActionId = id;
    }

    /**
     * Показать результат голосования
     * @private
     */
    private showVotingResult(data: any): void
    {
        if (this.isVotingEnded(data.detail)) {
            const optionsGroups = data.detail.data.optionsGroups[0];
            if (typeof optionsGroups !== 'undefined') {
                optionsGroups.options.forEach((option: any) => {
                    if (option.text === this.seat.id) {
                        this.votingResultMessage = data.detail;
                        this.votingResultIsVisible = true;
                        this.hideVoting();
                    }
                });
            }
        }
    }

    /**
     * Конец голосования
     */
    private isVotingEnded(message: any): boolean
    {
        const date = Math.floor(Date.now() / 1000);
        if (message.data && message.data.ended) {
            return !!message.data.ended;
        }

        return message.command === '/voteres'
            && (date >= message.data.endTime || message.data.endTime === null);
    }

    /**
     * Скрыть голосование
     * @private
     */
    private hideVotingResult(): void
    {
        this.votingResultIsVisible = false;
        this.votingResultMessage = null;
    }

    private makeDecision(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.isVoteDecisionDone = true;
    }

    private resetGame(): void
    {
        this.votingButtonIsVisible = false;
        this.votingResultIsVisible = false;
        this.votingResultMessage = null;
        this.isVoteDecisionDone = false;
        this.isVotingControlVisible = true;
        this.isPressedButtonAfterExecution = false;
        this.executedSeatId = '';
        this.nightActionId = '';
    }
}
